import CreateRequest from '@/apps/interviewRequest/new/CreateRequest.vue';
import WhatsNext from '@/apps/interviewRequest/new/WhatsNext.vue';

import { requireSeeker } from '../guards/authGuards';
import validateSitterUuid from '../guards/interviewRequestGuards';
import combineGuards from '../guards/helpers';

const interviewRequestRoutes = [
  {
    path: '/interview-request/:sitter_uuid/new',
    name: 'interview-request-new',
    component: CreateRequest,
    beforeEnter: combineGuards([requireSeeker, validateSitterUuid]),
  },
  {
    path: '/interview-request/:sitter_uuid/new/whats-next',
    name: 'interview-request-whats-next',
    component: WhatsNext,
    beforeEnter: requireSeeker,
  },
];

export default interviewRequestRoutes;
